'use strict';

angular.module('mobile-apps').controller('DeclineQuoteController', [
	'$scope',
	'$modalInstance',
	function (
		$scope,
		$modalInstance
	) {

		$scope.declineReason = '';


		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};


		/**
		 * Starts Add To TM process
		 */
		$scope.declineQuote = function () {

			var returnOptions = {
				reason: $scope.declineReason,
				decline: true
			};

			$modalInstance.close(returnOptions);
		};

	}
]);

